import React from 'react'
import './Attributes.css'
import { translation } from 'assets/translations/translations'

type Props = {
  language: string
}

const Attributes = ({ language }: Props) => {
  return (
    <section className='attributes-main'>
      <div className='attribute'>
        <span className='attribute-icon'>
          <i className='fas fa-check-circle' />
        </span>
        <span className='attribute-title'>
          {translation(language, 'qualitySolutions')}
        </span>
      </div>

      <div className='attribute'>
        <span className='attribute-icon'>
          <i className='fas fa-sliders-h' />
        </span>
        <span className='attribute-title'>
          {translation(language, 'fullyCustomizable')}
        </span>
      </div>

      <div className='attribute'>
        <span className='attribute-icon'>
          <i className='fas fa-lightbulb' />
        </span>
        <span className='attribute-title'>
          {translation(language, 'innovativeDesign')}
        </span>
      </div>
    </section>
  )
}

export default Attributes